// Shown when a request comes back 419: the session has expired, so the CSRF token baked
// into the page is stale and every further request will fail until it is reloaded.
//
// window.modal reuses the single dynamic modal, so repeat calls rewrite it rather than
// stacking. It is defined by app.js, which every master.blade.php page loads; a layout
// without it gets the browser's own dialog instead.
export function promptSessionExpired() {
    if (typeof window.modal !== 'function') {
        if (window.confirm('Your session has expired. Refresh the page to continue.')) {
            window.location.reload();
        }

        return;
    }

    window.modal(
        '<p>Your session has expired, so we could not complete that action.</p>'
        + '<p>Refresh the page to carry on.</p>'
        + '<p><button type="button" class="button" data-session-expired-refresh>Refresh the page</button></p>',
        'Session expired'
    );

    document.querySelector('[data-session-expired-refresh]')?.addEventListener('click', () => {
        window.location.reload();
    });
}
